import { server } from "../globalSettings";

export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}
// api
export const maybankAppointmentsListingApi = async ({ length, sort, page, name, appointment_at, status, sort_by }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}preemployment/admin_appointments?sort_order=${sort}&sort=${sort_by}&size=${length}&paginate=${page}&name=${name}&status=${status}&appointment_at=${appointment_at}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(["No data"]);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const maybankAppointmentsDetailsApi = async ({ id }) => {
    const request = requestAuthOption("GET")
    try {
        const response = await fetch(`${server}preemployment/admin_appointment/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data.data);
                    } else {
                        reject(data);
                    }
                } else {
                    reject(data);

                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addNewMaybankAppointments = async (maybankAppointments) => {
    const request = requestAuthOption("POST", maybankAppointments)
    try {
        const response = await fetch(`${server}preemployment/admin_appointment`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const delMaybankAppointments = async (id, data) => {
    const request = requestAuthOption("DELETE", data)
    try {
        const response = await fetch(`${server}preemployment/admin_appointment/delete/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject(data);
                        resolve(data);
                    }
                } else {
                    reject(data);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const updateMaybankAppointments = async ({ id, maybankAppointments }) => {
    const request = requestAuthOption("PUT", maybankAppointments)
    try {
        const response = await fetch(`${server}preemployment/admin_appointment/update/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        resolve(data);
                    } else {
                        reject([data]);
                        resolve(data);
                    }
                } else {
                    resolve(data);
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};
export const confirmAppointment = async ({ id, maybankAppointments }) => {

    const request = requestAuthOption("PUT", maybankAppointments)
    try {
        const response = await fetch(`${server}preemployment/admin_appointment/confirmed/${id}`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};

export const addRemarksPreEmploymentAppointment = async (payload) => {
    const request = requestAuthOption("PUT", payload?.maybankAppointments)
    try {
        const response = await fetch(`${server}preemployment/admin_appointment/${payload?.id}/remark`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        resolve(data);
                    } else if (data.code === "invalid_field") {
                        reject([data.errors]);
                        resolve(data.errors);
                    }
                } else {
                    reject(["Something went wrong, please try again later"]);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(["Network response error, please try again later"]);
                // throw error;
            })
        })

    }
};